// signupbutton.js
import React, { Component } from 'react';
import {
  FormGroup,
  FormControl,
  HelpBlock,
  Button,
  Modal
} from 'react-bootstrap';
import { connect } from 'react-redux';
import { register } from '../../../utils/apputils';
import { users } from '../../../store/actions';
import iconTip from '../../../static/images/icon-tip.svg';
import logo from '../../../static/images/logo-countpicula-dark.png';
import Spinner from '../../Spinner/Spinner.js';
import { passwordMinLength } from '../../../utils/user_config';

const mapStateToProps = state => ({
  status: state.users.status
});

class SignUpForm_Class extends Component {
  constructor(props) {
    super(props);
    this.state = {
      given_name: '',
      email: '',
      password: '',
      valid: true
    };
  }

  onChange = ({ target: { id, value } }) => {
    this.setState({
      [id]: value
    });
  };

  validate() {
    const { password } = this.state;
    return password.length > passwordMinLength;
  }

  getValidationState() {
    const { valid } = this.state;
    return valid ? null : 'error';
  }

  onSubmit = e => {
    e.preventDefault();
    const { dispatch } = this.props;
    const { email, given_name, password } = this.state;
    if (this.validate()) {
      // Need to make an async version of register, and need to bind dispatch to this class
      register(given_name, email, password, dispatch);
    } else {
      this.setState({ valid: false });
    }
  };

  handleClose = () => {
    const { dispatch } = this.props;
    dispatch(users.logout());
  };

  render() {
    const { status } = this.props;
    const { given_name, email, password } = this.state;
    return (
      <form onSubmit={this.onSubmit}>
        <div className="tint-box">
          <FormGroup controlId="given_name">
            <FormControl
              type="text"
              value={given_name}
              placeholder="Name"
              onChange={this.onChange}
              required
            />
          </FormGroup>
          <FormGroup controlId="email">
            <FormControl
              type="email"
              value={email}
              placeholder="Email address"
              onChange={this.onChange}
              required
            />
          </FormGroup>
          <FormGroup
            controlId="password"
            validationState={this.getValidationState()}
          >
            <FormControl
              type="Password"
              value={password}
              placeholder="Password"
              onChange={this.onChange}
              required
            />
            <HelpBlock className="smallprint">
              No fancy rules, but password must contain more than&nbsp;
              {passwordMinLength} characters.
            </HelpBlock>
          </FormGroup>
        </div>
        {status !== users.types.REGISTERING && (
          <div className="footer-buttons">
            <Button
              type="button"
              onClick={this.handleClose}
              className="btn-bevel"
            >
              Cancel
            </Button>
            <Button bsStyle="primary" type="submit" className="btn-bevel">
              Register
            </Button>
          </div>
        )}
        {status === users.types.REGISTER_FAILED && (
          <span className="error"> Email already registered</span>
        )}
        {status === users.types.REGISTERING && <Spinner type="regular" />}
      </form>
    );
  }
}
const SignUpForm = connect(mapStateToProps)(SignUpForm_Class);

class SignUpButton extends Component {
  handleClose = () => {
    const { dispatch } = this.props;
    dispatch(users.logout());
  };

  handleShow = () => {
    const { dispatch } = this.props;
    dispatch(users.show_register());
  };

  render() {
    const { status } = this.props;
    const show = [
      users.types.SHOW_REGISTER,
      users.types.REGISTERING,
      users.types.REGISTER_FAILED
    ].includes(status);

    return (
      <React.Fragment>
        <Button
          bsStyle="primary"
          className="btn btn-primary"
          onClick={this.handleShow}
        >
          Sign up
        </Button>
        <Modal show={show} onHide={this.handleClose} bsSize="large">
          <Modal.Header closeButton>
            <h2 className="modal-title" id="m_registerLabel">
              <span>Step into my lair</span>
            </h2>
            <img
              className="logo-img"
              src={logo}
              width="117"
              height="75"
              alt=""
            />
          </Modal.Header>
          <Modal.Body>
            <h3 className="bar-header">Create your account</h3>
            <div className="tint-box">
              <span>
                By creating a Count Picula account you&rsquo;ll be able to
                access your library of saved mockups, download them again at any
                time, buy credits and more.
              </span>
            </div>
            <SignUpForm close={this.handleClose} />
          </Modal.Body>
          <div className="modal-footer modal-footer--tip">
            <div>
              <img className="tip-icon" src={iconTip} width="310" alt="" />
              <div className="tip-text">
                <span>
                  Count Picula hates spam as much as you do; your email is
                  secure and used only for purchases.
                </span>
              </div>
            </div>
          </div>
        </Modal>
      </React.Fragment>
    );
  }
}

export default connect(mapStateToProps)(SignUpButton);



// WEBPACK FOOTER //
// ./src/comps/Navbar/components/SignUpButton.js